import styled from 'styled-components';
import { palette } from 'theme/MainTheme';
import { Menu } from 'zui/Antd';

export const StyledSitesMenu = styled(Menu)`
	border-inline-end: none !important;
	margin-top: 20px !important;

	.ant-menu-submenu {
		margin-bottom: 8px !important;
		padding: 0px 20px !important;
	}

	.ant-menu-submenu-title {
		padding: 0 16px !important;
		margin: 0 !important;
		width: 100% !important;
		min-height: 40px !important;
		height: auto !important;
		line-height: 24px !important;
		font-weight: 600 !important;
		font-size: 16px !important;
		color: #000000a6 !important;
		display: flex !important;
		align-items: center !important;
		margin-bottom: 8px !important;
		padding-top: 8px !important;
		padding-bottom: 8px !important;
	}

	.ant-menu-submenu-arrow {
		color: #000000a6 !important;
		font-size: 12px !important;
	}

	.ant-menu-submenu-inline > .ant-menu {
		background-color: #fafafa !important;
		border-radius: 8px !important;
	}

	.ant-menu-submenu-open > .ant-menu-submenu-title,
	.ant-menu-submenu-selected > .ant-menu-submenu-title {
		color: #001f97 !important;
	}

	.ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-submenu-arrow,
	.ant-menu-submenu-selected > .ant-menu-submenu-title .ant-menu-submenu-arrow {
		color: #001f97 !important;
	}

	.ant-menu-item {
		padding: 0 32px !important;
		margin: 0px !important;
		width: 100% !important;
		height: 40px !important;
		line-height: 22px !important;
		border-radius: 8px !important;
		font-size: 14px !important;
		font-weight: 400 !important;
		color: #000000a6 !important;
		cursor: default !important;
	}

	.ant-menu-item:hover {
		background-color: #fafafa !important;
	}

	.ant-menu-item-selected {
		color: #001f97 !important;
		font-weight: 600 !important;
	}

	.ant-menu-item::after,
	.ant-menu-submenu-title::after {
		display: none !important;
	}

	.ant-menu-item > div {
		width: 100% !important;
	}

	.no-floors-message {
		padding: 0 16px;
		color: ${palette('text', 2)};
		font-style: italic;
	}
`;
